
import React from 'react';

const ChurchSteepleServices = () => {
  const services = [
    {
      title: "Structural Reinforcement",
      description: "Addressing frame deterioration, load-bearing elements, and structural integrity using engineered reinforcement systems tested for Eastern NC's hurricane conditions and compliant with International Code Council standards."
    },
    {
      title: "Water Damage Restoration",
      description: "Comprehensive water infiltration solutions including custom flashing systems following NRCA specifications, premium sealants, and integrated drainage designed specifically for steeple architecture."
    },
    {
      title: "Ornamental Restoration",
      description: "Meticulous recreation of decorative elements, crosses, spires, and architectural details with historically accurate materials and techniques approved by the National Trust for Historic Preservation."
    },
    {
      title: "Lightning Protection",
      description: "Modern lightning protection systems that integrate harmoniously with historical architecture while providing comprehensive facility protection, certified to UL standards and NFPA 780 compliance."
    },
    {
      title: "Complete Steeple Rebuilds",
      description: "From-scratch reconstruction of severely damaged steeples with options for historical replication or modern, low-maintenance alternatives using premium materials from GAF, CertainTeed, and Owens Corning."
    },
    {
      title: "Bell Tower Integration",
      description: "Specialized solutions for bell-supporting steeples, including structural reinforcement, sound management, and vibration mitigation following Building Science Corporation moisture control protocols."
    }
  ];

  return (
    <section id="services" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold mb-10 text-center">Comprehensive Church Steeple Repair Services</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow">
              <div className="p-6">
                <h3 className="font-bold text-xl mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChurchSteepleServices;
